import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

const _import = (path) => () => import(`@/views/${path}/index.vue`);

export const routes = [
  {
    path: '/', name: 'Portal', alias: '/index', component: _import('Portal'), // 展示
    children: [
      {path: '/', name: 'Home', alias: '/home', component: _import('Home')},  // 首页
      {
        path: '/product', name: 'Product', component: _import('Portal/Product'), children: [  // 产品页
          {path: '/DataOps', name: 'BigDataOps', component: _import('Ops')},
          {path: '/IoTOps', name: 'IotOps', component: _import('Ops')},
          {path: '/AIOps', name: 'AIOps', component: _import('Ops')},
          {path: '/MarketingOps', name: 'MarketingOps', component: _import('Ops')},
          {path: '/RecommendationOps', name: 'RecommendationOps', component: _import('Ops')},
        ]
      },
      {
        path: '/solution', name: 'Solution', component: _import('Solution'), children: [  // 解决方案页
          {path: '/FaceSaaS', name: 'FaceSaaS', component: _import('Solution/faceSaaS')},
          {path: '/PrecisionMarketing', name: 'PrecisionMarketing', component: _import('Solution/PrecisionMarketing')},
          {path: '/Recommendation', name: 'Recommendation', component: _import('Solution/Recommendation')},
          {path: '/DigitalCity', name: 'DigitalCity', component: _import('Solution/DigitalCity')},
          {path: '/DigitalEducation', name: 'DigitalEducation', component: _import('Solution/DigitalEducation')},
        ]
      },
      {path: '/Price', name: 'Price', component: _import("Price")}, // 价格页
      {path: '/about', name: 'AboutUs', component: _import("AboutUs")}, // 关于我们页
    ]
  },
  {
    path: 'management', name: 'Management', component: _import('Management'), children: [ // 管理
      {path: '/ops', name: 'OpsManagement', component: _import('OpsManagement')}, // ops管理页
      {
        path: '/login', name: 'Login', component: _import('Login'), children: [ // 登录页
          {path: '/login', name: 'LoginForm', component: _import('Login/LoginForm')}, // 登录页
          {path: '/guest', name: 'GuestForm', component: _import('Login/GuestForm')}, // 留资页
        ]
      },
    ]
  },
  {path: '/404', name: '404', component: _import('haveNotThisPage')},
  {path: '*', redirect: '/404'},
];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;
